export const checkinList = {
  group: {
    sectionTitle: "تسجيلات الدخول المرتبطة",
    registrationForm: "استمارة التسجيل",
    registrationFormHint: "مستند واحد يضم صاحب الحجز ومرافقيه",
    registrationFormEmpty: "لم يتم إنجاز أي تسجيل وصول في هذا الحجز بعد.",
    registrationFormError: "تعذّر إنشاء الاستمارة. حاول مرة أخرى.",
    emptyState: "لا توجد تسجيلات دخول مرتبطة.",
    name: "الاسم",
    phone: "الهاتف",
    document: "الوثيقة",
    notAvailable: "غير متوفر",
    syncSent: "أُرسل إلى دائرة الهجرة",
    syncError: "خطأ في الإرسال إلى دائرة الهجرة",
    syncPending: "في انتظار الإرسال",
    moreInfo: "مزيد من المعلومات",
    email: "البريد الإلكتروني",
    checkIn: "تسجيل الدخول",
    checkOut: "تسجيل الخروج",
    docType: "نوع الوثيقة",
    supportNumber: "رقم الدعم",
    documentBack: "الظهر",
    identityNoMatch: "الوجهان غير متطابقين",
    identityStored: "بدون مقارنة بالوجه",
    identityError: "تعذّرت المقارنة",
    identityNoPhotos: "لا تُحفظ الصور في هذا البلد: تبقى النتيجة فقط.",
    identityVerification: "التحقق من الهوية",
    tapToEnlarge: "اضغط للتكبير",
    view: "عرض",
    download: "تنزيل",
    selfie: "صورة ذاتية",
    minorData: "بيانات القاصر",
    relationship: "صلة القرابة:",
    noPhotos: "لا توجد صور مرفقة.",
    minorDocument: "وثيقة القاصر",
    authorization: "التفويض",
    minorAuthorization: "تفويض القاصر",
    specification: "التحديد:",
    additionalInfo: "معلومات إضافية",
    nationality: "الجنسية",
    birthDate: "تاريخ الميلاد",
    ageYears: "({age} سنة)",
    gender: "الجنس",
    female: "أنثى",
    male: "ذكر",
    countryResidence: "بلد الإقامة",
    cityResidence: "مدينة الإقامة",
    address: "العنوان",
    zipCode: "الرمز البريدي",
    sesBatchId: "معرّف دفعة SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "بلد الميلاد",
    docIssuePlace: "مكان إصدار الوثيقة",
    signedDocument: "الوثيقة الموقّعة",
    edit: "تعديل",
    remove: "حذف",
    previewAlt: "معاينة",
    previewFallbackTitle: "صورة",
    docTypes: {
      passport: "جواز سفر",
      passportOrdinary: "جواز سفر عادي",
      passportService: "جواز سفر خدمة",
      passportDiplomatic: "جواز سفر دبلوماسي",
      idCard: "بطاقة هوية",
      nie: "NIE",
      idCardElectronic: "بطاقة هوية إلكترونية",
      idDiplomatic: "وثيقة هوية دبلوماسية",
      citizenshipCard: "بطاقة مواطنة",
      foreignerCard: "بطاقة إقامة أجنبي",
      drivingLicense: "رخصة قيادة",
      nauticalLicense: "رخصة إبحار",
      specialResidencePermit: "تصريح إقامة خاص",
      foreignerDocument: "وثيقة أجنبي",
      foreignDocument: "وثيقة أجنبية",
      diplomaticCard: "بطاقة دبلوماسية",
      refugeeTravelDocument: "وثيقة سفر لاجئ",
      otherDocument: "وثيقة أخرى",
    },
  },
  individual: {
    title: "بيانات النزيل",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    notAvailable: "غير متوفر",
    lodging: "الإقامة",
    docType: "نوع الوثيقة",
    docNumber: "رقم الوثيقة",
    supportNumber: "رقم الدعم",
    identityVerification: "التحقق من الهوية",
    document: "الوثيقة",
    tapToEnlarge: "اضغط للتكبير",
    view: "عرض",
    download: "تنزيل",
    selfie: "صورة ذاتية",
    minorData: "بيانات القاصر",
    relationship: "صلة القرابة:",
    noPhotos: "لا توجد صور مرفقة.",
    minorDocument: "وثيقة القاصر",
    authorization: "التفويض",
    minorAuthorization: "تفويض القاصر",
    specification: "التحديد:",
    additionalInfo: "معلومات إضافية",
    nationality: "الجنسية",
    birthDate: "تاريخ الميلاد",
    ageYears: "({age} سنة)",
    gender: "الجنس",
    female: "أنثى",
    male: "ذكر",
    countryResidence: "بلد الإقامة",
    cityResidence: "مدينة الإقامة",
    address: "العنوان",
    zipCode: "الرمز البريدي",
    sesBatchId: "معرّف دفعة SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "بلد الميلاد",
    docIssuePlace: "مكان إصدار الوثيقة",
    signedDocument: "الوثيقة الموقّعة",
    edit: "تعديل",
    previewAlt: "معاينة",
    previewFallbackTitle: "صورة",
    docTypes: {
      passport: "جواز سفر",
      passportOrdinary: "جواز سفر عادي",
      passportService: "جواز سفر خدمة",
      passportDiplomatic: "جواز سفر دبلوماسي",
      idCard: "بطاقة هوية",
      nie: "NIE",
      idCardElectronic: "بطاقة هوية إلكترونية",
      idDiplomatic: "وثيقة هوية دبلوماسية",
      citizenshipCard: "بطاقة مواطنة",
      foreignerCard: "بطاقة إقامة أجنبي",
      drivingLicense: "رخصة قيادة",
      nauticalLicense: "رخصة إبحار",
      specialResidencePermit: "تصريح إقامة خاص",
      foreignerDocument: "وثيقة أجنبي",
      foreignDocument: "وثيقة أجنبية",
      diplomaticCard: "بطاقة دبلوماسية",
      refugeeTravelDocument: "وثيقة سفر لاجئ",
      otherDocument: "وثيقة أخرى",
    },
  },
};
